export const SET_THEME = 'SET_THEME'

export const THEMES = [
  'default',
  'ocean-breeze',
  'sunset-glow',
  'forest-night',
  'neon-pulse',
  'minimal-zen'
]

const setTheme = (theme) => ({
  type: SET_THEME,
  payload: theme
})

export default {
  setTheme
}
